/**
 * @function exists check if item exists (if not null or undefined)
 * @param {*} item - item to check.
 * @param {boolean} allowEmptyStrings - allow empty strings.
 * @returns {boolean} - returns true if item exists.
 */
export function exists(item, allowEmptyStrings = false) {
	return !(item === null || item === undefined || (!allowEmptyStrings && item === ""));
}
